<template>
  <div>
    <!-- Loading Table -->
    <j-loading-table v-if="isLoading"/>

    <!-- List Apps -->
    <v-client-table
      v-show="!isLoading"
      :data="data_apps"
      :columns="columns"
      :options="table_options"
      class="jTable"
    >
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="toggleModalCreateApp(true)">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-form
            inline
            @keypress.13.prevent="filter(filter_data)"
          >
            <j-select
              v-model="select_type"
              :options="options_search"
              placeholder="Filter By"
              class="m__r--5"
            />
            <b-form-input
              ref="filterInputApp"
              v-model="filter_data"
              type="text"
              placeholder="Search"
              style="width: 250px; height: 35px"
            />
          </b-form>
        </b-form>
      </div>

      <div
        slot="id"
        slot-scope="props"
        @click="detailApp(props.row.id_hash)">
        {{ props.row.id }}
      </div>

      <div
        slot="icon"
        slot-scope="props"
        @click="detailApp(props.row.id_hash)">
        <img
          v-if="props.row.icon"
          :src="props.row.icon"
          width="32">
      </div>

      <div
        slot="name"
        slot-scope="props"
        @click="detailApp(props.row.id_hash)">
        {{ props.row.name }}
      </div>

      <div
        slot="is_offline_mode"
        slot-scope="props"
        @click="detailApp(props.row.id_hash)">
        <div
          v-if="props.row.is_offline_mode"
          class="vp-on">ON</div>
        <div
          v-else
          class="vp-off">OFF</div>
      </div>

      <div
        slot="total_page"
        slot-scope="props"
        @click="detailApp(props.row.id_hash)">
        {{ props.row.total_page || 0 }}
      </div>

      <div
        slot="created_at"
        slot-scope="props"
        @click="detailApp(props.row.id_hash)">
        {{ convertDateTime(props.row.created_at) }}
      </div>

      <div
        slot="updated_at"
        slot-scope="props"
        @click="detailApp(props.row.id_hash)">
        {{ convertDateTime(props.row.updated_at) }}
      </div>
    </v-client-table>

    <b-modal
      ref="modalCreateApp"
      hide-header
      hide-footer
      centered
      no-close-on-esc
      no-close-on-backdrop
      class="modal-create-app"
    >
      <j-modal-create-app
        v-if="isShowModalCreateApp"
        @close-modal="toggleModalCreateApp"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// Components
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jModalCreateApp from '@/views/application-manager/tabs/partials/jModalCreateApp';

export default {
  components: {
    jLoadingTable,
    jModalCreateApp,
  },

  data() {
    return {
      isLoading: true,
      isShowModalCreateApp: false,
      data_apps: [],
      filter_data: '',
      select_type: 'name',
      options_search: [
        {
          text: 'Name',
          value: 'name',
        },
      ],
      columns: ['id', 'icon', 'name', 'is_offline_mode', 'total_page', 'created_at', 'updated_at'],
      table_options: {
        headings: {
          id: 'ID',
          icon: 'LOGO',
          name: 'NAME',
          is_offline_mode: 'OFFLINE MODE',
          total_page: 'TOTAL PAGES',
          created_at: 'CREATED AT',
          updated_at: 'UPDATED AT',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        filterable: true,
        perPage: 10,
        perPageValues: [10, 50, 100, 500, 1000],
      },
    };
  },

  computed: {
    ...mapState('jStoreSetting', ['applications_list']),
  },

  watch: {
    applications_list(val) {
      this.data_apps = val;
    },

    isLoading(val) {
      if (!val) {
        setTimeout(() => {
          this.$refs.filterInputApp.focus();
        }, 200);
      }
    },
  },

  created() {
    setTimeout(() => {
      this.data_apps = this.applications_list;
      this.isLoading = false;
    }, 400);
  },

  methods: {
    filter(val) {
      this.data_apps = this.applications_list.filter(app =>
        app.name.toUpperCase().includes(val.toUpperCase()));
    },

    toggleModalCreateApp(val) {
      if (val) {
        this.isShowModalCreateApp = true;
        this.$refs.modalCreateApp.show();
      } else {
        this.isShowModalCreateApp = false;
        this.$refs.modalCreateApp.hide();
      }
    },

    detailApp(id) {
      this.$router.push(`/application-manager/general/${id}`);
    },

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/tabs/jApplicationAppTab.vue